import http from '@plugin/axios'
import store from '@plugin/store'
import router from '@plugin/router'

class Submit {
  constructor(data: object, tabIndex: number) {
    this.sendData(data, tabIndex)
  }

  async sendData(data: object, tabIndex: number) {
    switch (tabIndex) {
      case 0:
        http({
          url: '/license/activateByLicenseNo',
          baseURL: process.env.VUE_APP_BASE_API,
          data
        }).then(async() => {
          await store.dispatch('app/exit')
          router.push('/')
        })
        break

      case 1:
        http({
          url: '/license/activateByFile',
          baseURL: process.env.VUE_APP_BASE_API,
          data
        }).then(async() => {
          await store.dispatch('app/exit')
          router.push('/')
        })
        break
    }
  }
}

export default Submit
